import { Component, Input, Output, EventEmitter, NgModule } from '@angular/core';
import '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class NgRatingBarComponent {
    constructor() {
        this.valueChange = new EventEmitter();
        this.hoverChange = new EventEmitter();
        this.numbers = [];
        this.hoverIndex = -1;
        this.selectedValue = 0;
        this.halfValue = 0;
        this.halfIndex = -1;
        this.isHovered = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.ratingCount = this.ratingCount || 5;
        this.colorActive = this.colorActive || '#edb867';
        this.colorDefault = this.colorDefault || '#d2d2d2';
        if (!this.styles) {
            this.styles = {
                fontSize: '28px',
                backgroundColor: '',
                margin: '5px'
            };
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes["value"] || this.control) {
            this.initNumbers();
            this.calculateHalfValue();
        }
    }
    /**
     * @return {?}
     */
    initNumbers() {
        this.numbers = Array(this.ratingCount)
            .fill(0)
            .map((x, i) => i);
        if (this.control) {
            this.selectedValue = this.control.value;
        }
        else {
            this.selectedValue = this.value;
        }
        this.hoverIndex = this.selectedValue - 1;
    }
    /**
     * @param {?} i
     * @return {?}
     */
    enter(i) {
        if (this.disabled) {
            return;
        }
        this.isHovered = true;
        this.hoverIndex = i;
        this.hoverChange.emit(1 + i);
    }
    /**
     * @param {?} i
     * @return {?}
     */
    leave(i) {
        if (this.disabled) {
            return;
        }
        this.isHovered = false;
        this.hoverIndex = this.selectedValue - 1;
    }
    /**
     * @param {?} i
     * @return {?}
     */
    setSelected(i) {
        if (this.disabled) {
            return;
        }
        if (this.resetAble && this.selectedValue === i + 1) {
            this.selectedValue = 0;
        }
        else {
            this.selectedValue = i + 1;
        }
        if (this.control) {
            this.control.setValue(this.selectedValue || null);
            this.control.markAsTouched();
        }
        else {
            this.valueChange.emit(this.selectedValue);
        }
        this.isHovered = false;
        this.calculateHalfValue();
    }
    /**
     * @return {?}
     */
    calculateHalfValue() {
        this.halfValue = Math.round(100 * (this.selectedValue - Math.floor(this.selectedValue)));
        this.halfIndex = Math.ceil(this.selectedValue) - 1;
    }
}
NgRatingBarComponent.decorators = [
    { type: Component, args: [{
                selector: 'ng-rating-bar',
                template: `<ng-container *ngFor="let item of numbers; let i = index">
  <span
    class="star"
    (mouseenter)="enter(i)"
    (mouseleave)="leave(i)"
    (click)="setSelected(i)"
    [ngStyle]="{'color': (i <= hoverIndex) ? colorActive : colorDefault}"
    [style.fontSize]="styles.fontSize"
    [style.backgroundColor]="styles.backgroundColor"
    [style.marginRight]="styles.margin"
  >
  ★
  <span
    class="star half"
    *ngIf="!isHovered && i == halfIndex"
    [style.width.%]="halfValue"
    [style.color]="colorActive"
  >★</span>
</span>
</ng-container>
`,
                styles: [`.star{position:relative}.star:not(.half){min-height:20px;min-width:20px;cursor:pointer;display:inline-block}.star.active{color:inherit}.star.half{height:inherit;font-size:inherit;cursor:pointer;position:absolute;left:0;top:0;display:inline-block;overflow:hidden}`]
            },] },
];
/** @nocollapse */
NgRatingBarComponent.ctorParameters = () => [];
NgRatingBarComponent.propDecorators = {
    ratingCount: [{ type: Input }],
    colorActive: [{ type: Input }],
    colorDefault: [{ type: Input }],
    disabled: [{ type: Input }],
    resetAble: [{ type: Input }],
    control: [{ type: Input }],
    styles: [{ type: Input }],
    value: [{ type: Input }],
    valueChange: [{ type: Output }],
    hoverChange: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class NgRatingBarModule {
}
NgRatingBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [NgRatingBarComponent],
                exports: [NgRatingBarComponent]
            },] },
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { NgRatingBarModule, NgRatingBarComponent as ɵa };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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